import IconArrow from '@mui/icons-material/ArrowUpward'
import DeleteIcon from '@mui/icons-material/Close'
import IconDragHandle from '@mui/icons-material/DragIndicator'
import Checkbox from '@mui/material/Checkbox'
import IconButton from '@mui/material/IconButton'
import styles from './BulkPost.pcss'

interface BulkPostActionsProps {
  postId: string
  selected: boolean
  dndAttributes: any
  dndListeners: any
  onMoveToTop: (id: string) => void
  onMoveToBottom: (id: string) => void
  onRemove: (id: string) => void
  onToggleSelected: (id: string) => void
}

export function BulkPostActions(props: BulkPostActionsProps) {
  const { postId, selected, dndAttributes, dndListeners } = props

  const moveToTop = () => {
    props.onMoveToTop(postId)
  }

  const moveToBottom = () => {
    props.onMoveToBottom(postId)
  }

  const remove = () => {
    props.onRemove(postId)
  }

  const toggleSelected = () => {
    props.onToggleSelected(postId)
  }

  return (
    <div className={styles['actions-box']}>
      <div className={styles['actions-left']}>
        <IconButton size="small" onClick={moveToTop}>
          <IconArrow />
        </IconButton>
        <IconButton size="small" onClick={moveToBottom}>
          <IconArrow className={styles.flip} />
        </IconButton>
      </div>
      <div className={styles['drag-handle']} {...dndListeners} {...dndAttributes}>
        <IconDragHandle className={styles['icon-drag']} />
      </div>
      <div className={styles['actions-right']}>
        <IconButton size="small" onClick={remove}>
          <DeleteIcon />
        </IconButton>
        <Checkbox
          checked={selected}
          color="primary"
          onChange={toggleSelected}
        />
      </div>
    </div>
  )
}
